import React from "react";
import Navbar from "../components/navbars/Navbar";
const Home = () => {
  return (
    <Navbar>
      <div>home page</div>
    </Navbar>
  );
};

export default Home;
